import { ZoomDialog } from './zoom-dialog.js';

// Extend the theme gallery only; the calculator and its image remain independent.
class WallMuralZoom extends ZoomDialog {
  async open(index, event) {
    this.returnFocus = event.target.closest('button');
    await super.open(index, event);
    this.selectThumbnail(Number(index), { behavior: 'instant' });
    this.refs.dialog.querySelector('.wall-mural-zoom-close').focus({ preventScroll: true });
  }

  previous() { this.move(-1); }
  next() { this.move(1); }

  move(direction) {
    const buttons = Array.from(this.refs.thumbnails.children);
    const current = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-selected') === 'true'));
    this.selectThumbnail((current + direction + buttons.length) % buttons.length, { behavior: 'instant' });
  }

  handleKeyDown(event) {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      this.move(event.key === 'ArrowLeft' ? -1 : 1);
    } else {
      super.handleKeyDown(event);
    }
  }

  closeDialog() {
    super.closeDialog();
    this.returnFocus?.focus({ preventScroll: true });
  }
}

if (!customElements.get('wall-mural-zoom')) customElements.define('wall-mural-zoom', WallMuralZoom);
